// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"446":"a824fc2e","565":"7a0b73ba","668":"a824fc2e","772":"a824fc2e","816":"a824fc2e","921":"f6d71a80","928":"f6d71a80","971":"a824fc2e","988":"a824fc2e"}[chunkId] + ".chunk.css";
};